import React from 'react';
export function Icon({ name }) {
    const iconData = iconList.find(icon => icon.name === name);
    if (!iconData)
        return null;
    const paths = Array.from({ length: iconData.paths }, (_, index) => (React.createElement("span", { className: `path${index + 1}`, key: index })));
    return React.createElement("i", { className: `ltg-icon ltg-icon${name}` }, paths);
}
const iconList = [
    {
        "name": "Rail-Baltica-koordinavimo-dep",
        "paths": 2
    },
    {
        "name": "Aplinkosauga",
        "paths": 2
    },
    {
        "name": "Apsaugos-paslaugos",
        "paths": 4
    },
    {
        "name": "Apsikeitimas-duomenimis",
        "paths": 4
    },
    {
        "name": "Aptarnaujantis-personalas",
        "paths": 2
    },
    {
        "name": "Atsiskaitymas-mokejimo-kortele",
        "paths": 3
    },
    {
        "name": "Atstovybe",
        "paths": 3
    },
    {
        "name": "Atstovybiu-tinklas",
        "paths": 5
    },
    {
        "name": "Augimas",
        "paths": 4
    },
    {
        "name": "Baltijos-salys",
        "paths": 7
    },
    {
        "name": "Begiu-statybos",
        "paths": 4
    },
    {
        "name": "Bendradarbiavimas-susitarimai",
        "paths": 4
    },
    {
        "name": "Bilietas",
        "paths": 3
    },
    {
        "name": "Bilietu-kasa",
        "paths": 3
    },
    {
        "name": "CRM",
        "paths": 2
    },
    {
        "name": "Darbo-akiniai",
        "paths": 3
    },
    {
        "name": "Darbuotojai-Komanda",
        "paths": 4
    },
    {
        "name": "Darbuotojas",
        "paths": 2
    },
    {
        "name": "Dezinfekatorius",
        "paths": 2
    },
    {
        "name": "Diagnostikos-dep",
        "paths": 2
    },
    {
        "name": "Diagnostikos-vagonas",
        "paths": 3
    },
    {
        "name": "Dirbame-visa-para",
        "paths": 6
    },
    {
        "name": "Dokumento-rengimas",
        "paths": 4
    },
    {
        "name": "Dviratis",
        "paths": 5
    },
    {
        "name": "E-bilietas",
        "paths": 2
    },
    {
        "name": "Eismininkas",
        "paths": 3
    },
    {
        "name": "Eismo-valdymo-dep",
        "paths": 2
    },
    {
        "name": "E-krovinys",
        "paths": 3
    },
    {
        "name": "Ekspedijavimas_Ekspedijavimas",
        "paths": 6
    },
    {
        "name": "Elektra",
        "paths": 2
    },
    {
        "name": "Elektroninis-pastas",
        "paths": 4
    },
    {
        "name": "ES",
        "paths": 2
    },
    {
        "name": "Facebook",
        "paths": 2
    },
    {
        "name": "Fotoaparatas",
        "paths": 2
    },
    {
        "name": "Gamyba",
        "paths": 3
    },
    {
        "name": "Garsiakalbis",
        "paths": 4
    },
    {
        "name": "Gelezinkelio-iesmas",
        "paths": 2
    },
    {
        "name": "Gelezinkelio-veziu-sankirta",
        "paths": 2
    },
    {
        "name": "Gelezinkelis-Veze",
        "paths": 8
    },
    {
        "name": "Gyvunai",
        "paths": 5
    },
    {
        "name": "Greitis",
        "paths": 6
    },
    {
        "name": "HR-paslaugos",
        "paths": 4
    },
    {
        "name": "Ideja-Lempa",
        "paths": 3
    },
    {
        "name": "Infocentras",
        "paths": 2
    },
    {
        "name": "Infrastrukturos-paslaugu-dep",
        "paths": 2
    },
    {
        "name": "Inovacijos-Modernumas",
        "paths": 3
    },
    {
        "name": "Instagram",
        "paths": 3
    },
    {
        "name": "Intermodaliniu-terminalu-paslaugos",
        "paths": 2
    },
    {
        "name": "Interneto-svetaine",
        "paths": 2
    },
    {
        "name": "Irankiai",
        "paths": 3
    },
    {
        "name": "Ispejimas",
        "paths": 2
    },
    {
        "name": "Is-tasko-A-i-taska-B",
        "paths": 5
    },
    {
        "name": "IT-pagalba",
        "paths": 2
    },
    {
        "name": "Juriniai-ir-saldantys-konteineriai",
        "paths": 2
    },
    {
        "name": "Kariniai-kroviniai",
        "paths": 5
    },
    {
        "name": "Kauke",
        "paths": 6
    },
    {
        "name": "Kavos-puodelis",
        "paths": 5
    },
    {
        "name": "Keleivis",
        "paths": 2
    },
    {
        "name": "Kelio-darbininkas",
        "paths": 3
    },
    {
        "name": "Kitos-paslaugos",
        "paths": 6
    },
    {
        "name": "Klientai-is-viso-pasaulio",
        "paths": 2
    },
    {
        "name": "Kompiuteris",
        "paths": 3
    },
    {
        "name": "Konteineriai",
        "paths": 2
    },
    {
        "name": "Konteineris",
        "paths": 3
    },
    {
        "name": "Kontora",
        "paths": 3
    },
    {
        "name": "Korona-virusas",
        "paths": 4
    },
    {
        "name": "Koronos-linija",
        "paths": 2
    },
    {
        "name": "Korporatyvines-veiklos-dep",
        "paths": 2
    },
    {
        "name": "Kranas-virs-begiu",
        "paths": 2
    },
    {
        "name": "Krova-ir--Sandeliavimas",
        "paths": 2
    },
    {
        "name": "Krova",
        "paths": 2
    },
    {
        "name": "Krovos-fronto-ilgis",
        "paths": 2
    },
    {
        "name": "Lagaminai",
        "paths": 2
    },
    {
        "name": "Laikrodis",
        "paths": 3
    },
    {
        "name": "Liemene",
        "paths": 2
    },
    {
        "name": "Lietuva---transporto-ir-logistikos-tiltas",
        "paths": 3
    },
    {
        "name": "Lietuvos-atvaizdas",
        "paths": 2
    },
    {
        "name": "Linkedin",
        "paths": 4
    },
    {
        "name": "Lokomotyvas-Kroviniu-vezimas",
        "paths": 3
    },
    {
        "name": "Maisto-ikona",
        "paths": 4
    },
    {
        "name": "Medis",
        "paths": 3
    },
    {
        "name": "Meniu",
        "paths": 3
    },
    {
        "name": "Misko-zveris",
        "paths": 2
    },
    {
        "name": "Mobilios-krovos-brigados",
        "paths": 2
    },
    {
        "name": "Mobilusis-telefonas",
        "paths": 3
    },
    {
        "name": "Mokejimas-kortele",
        "paths": 3
    },
    {
        "name": "Muitine-pasienis",
        "paths": 3
    },
    {
        "name": "Multimodaliniai-pervezimai",
        "paths": 5
    },
    {
        "name": "Naujienos",
        "paths": 2
    },
    {
        "name": "Neigalieji",
        "paths": 3
    },
    {
        "name": "Nesiojamas-kompiuteris",
        "paths": 2
    },
    {
        "name": "Nextcloud-debesis",
        "paths": 2
    },
    {
        "name": "Nuomos-paslaugos",
        "paths": 5
    },
    {
        "name": "OK-zenklas",
        "paths": 2
    },
    {
        "name": "Operatyviniai-duomenys",
        "paths": 2
    },
    {
        "name": "Ozinis-konteinerinis-kranas",
        "paths": 2
    },
    {
        "name": "Pabegiai",
        "paths": 4
    },
    {
        "name": "Padetis-Vieta",
        "paths": 2
    },
    {
        "name": "Pagrindine-bustine",
        "paths": 2
    },
    {
        "name": "Pajegumai",
        "paths": 2
    },
    {
        "name": "Parasas",
        "paths": 3
    },
    {
        "name": "Pasiekimai",
        "paths": 2
    },
    {
        "name": "Pastatu-administravimas",
        "paths": 4
    },
    {
        "name": "Pasto-ikona",
        "paths": 2
    },
    {
        "name": "Patikima-logistika",
        "paths": 2
    },
    {
        "name": "Patirtis",
        "paths": 5
    },
    {
        "name": "Pavirsiaus-dezinfekavimas",
        "paths": 5
    },
    {
        "name": "Peronas",
        "paths": 3
    },
    {
        "name": "Pervaza",
        "paths": 3
    },
    {
        "name": "Pervazos-stulpas",
        "paths": 2
    },
    {
        "name": "Pinigu-maisas",
        "paths": 2
    },
    {
        "name": "Pirkimai-Pinigai",
        "paths": 2
    },
    {
        "name": "Pirstines",
        "paths": 2
    },
    {
        "name": "Pokytis",
        "paths": 2
    },
    {
        "name": "Procesas",
        "paths": 2
    },
    {
        "name": "Profesiniai-mokymai-Moodle",
        "paths": 3
    },
    {
        "name": "Projektas",
        "paths": 2
    },
    {
        "name": "Projektu-valdymas",
        "paths": 2
    },
    {
        "name": "Projektu-valdymo-dep",
        "paths": 2
    },
    {
        "name": "Ranku-plovimas",
        "paths": 4
    },
    {
        "name": "Redmine",
        "paths": 2
    },
    {
        "name": "Renginiai",
        "paths": 5
    },
    {
        "name": "Rentgenas",
        "paths": 3
    },
    {
        "name": "Riedmenu-parkas",
        "paths": 3
    },
    {
        "name": "Rysio-antena",
        "paths": 4
    },
    {
        "name": "Sandeliavimas",
        "paths": 2
    },
    {
        "name": "Saugojimo-paslaugos",
        "paths": 2
    },
    {
        "name": "Saugu",
        "paths": 2
    },
    {
        "name": "Saugus-atstumas",
        "paths": 6
    },
    {
        "name": "Saugus-begiai_Saugus-begiai",
        "paths": 4
    },
    {
        "name": "Saule",
        "paths": 9
    },
    {
        "name": "Semaforas",
        "paths": 3
    },
    {
        "name": "Sensoriai",
        "paths": 3
    },
    {
        "name": "Sergantis-asmuo-kosejimas",
        "paths": 9
    },
    {
        "name": "Sienele-nuo-triuksmo",
        "paths": 4
    },
    {
        "name": "Siuntu-paslauga",
        "paths": 3
    },
    {
        "name": "Skaiciuotuvas",
        "paths": 2
    },
    {
        "name": "Sprendimu-priemimas",
        "paths": 3
    },
    {
        "name": "Stebejimo-kamera",
        "paths": 2
    },
    {
        "name": "Stoties-laikrodis",
        "paths": 3
    },
    {
        "name": "Stotis",
        "paths": 2
    },
    {
        "name": "Strategija",
        "paths": 2
    },
    {
        "name": "Strategijos-ir-valdymo-dep",
        "paths": 2
    },
    {
        "name": "Stulpas",
        "paths": 2
    },
    {
        "name": "Susitarimas-Bendras-tikslas",
        "paths": 3
    },
    {
        "name": "Sutaupymas",
        "paths": 2
    },
    {
        "name": "Svarstykles",
        "paths": 3
    },
    {
        "name": "Sachmatinis-sedejimas",
        "paths": 6
    },
    {
        "name": "Salmas",
        "paths": 2
    },
    {
        "name": "Siuksliadeze",
        "paths": 3
    },
    {
        "name": "Sviesoforas",
        "paths": 2
    },
    {
        "name": "Svilpukas",
        "paths": 4
    },
    {
        "name": "Tarptautiniai-transporto-koridoriai",
        "paths": 2
    },
    {
        "name": "Technines-integracijos-dep",
        "paths": 2
    },
    {
        "name": "Technines-prieziuros-dep",
        "paths": 2
    },
    {
        "name": "Telefonas",
        "paths": 3
    },
    {
        "name": "Tiekimo-grandine",
        "paths": 3
    },
    {
        "name": "Tikslai-Taikinys",
        "paths": 4
    },
    {
        "name": "Tiltas",
        "paths": 3
    },
    {
        "name": "Touch-funkcija",
        "paths": 3
    },
    {
        "name": "Traukinys-is-priekio",
        "paths": 2
    },
    {
        "name": "Triuksmo-ausines",
        "paths": 3
    },
    {
        "name": "Trukme-Smelio-laikrodis",
        "paths": 3
    },
    {
        "name": "Tunelis",
        "paths": 2
    },
    {
        "name": "Vagonai",
        "paths": 3
    },
    {
        "name": "Vagono-ratas",
        "paths": 2
    },
    {
        "name": "Vagonu-remontas",
        "paths": 2
    },
    {
        "name": "Vandens-telkinys",
        "paths": 3
    },
    {
        "name": "Viber",
        "paths": 2
    },
    {
        "name": "Viesieji-pirkimai",
        "paths": 2
    },
    {
        "name": "Vilkikas-su-puspriekabe",
        "paths": 4
    },
    {
        "name": "Visas-zmogus",
        "paths": 3
    },
    {
        "name": "Viskas-vienose-rankose",
        "paths": 2
    },
    {
        "name": "Whatsapp",
        "paths": 2
    },
    {
        "name": "WIFI",
        "paths": 4
    }
];
